import { render, staticRenderFns } from "./EducationalGroupChangeActivationType.vue?vue&type=template&id=5c8b0e56&"
import script from "./EducationalGroupChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports